<!--  -->
<template>
  <van-popup
    class="popup"
    v-model="show"
    :round="true"
    @click-overlay="close"
  >
    <div
      class="share"
      ref="imageWrapper"
      v-show="!imgUrl"
    >
      <div class="share-head">
        <img
          src="https://ark-test-cdn-images.iqihang.com/image/20220805/da3b33de57c549dcaf310a8122bb8151.png"
          alt=""
        />
        <h1 class="title">最近学习时间：{{ studyInfo.lastLearnTime || '--'}}</h1>
      </div>
      <section class="section">
        <h2 class="course-name">{{ this.$route.query.productName }}</h2>
        <StudyProgress :studyInfo="studyInfo" />
        <div class="qihang">
          <img
            class="logo"
            src="https://ark-test-cdn-images.iqihang.com/image/20220805/dd40849f0bfe45fc9c6a997cfabfeaaa.png"
          />
          <img
            class="code"
            :src="qrcode"
          />
        </div>
      </section>
    </div>
    <div
      class="share"
      v-show="imgUrl"
    >
      <img
        class="poster"
        :src="imgUrl"
        alt=""
      />
    </div>
    <div
      class="share-btn"
      @click="close"
      v-if="!this.$root.isApp"
    >
      <span>长按或截图保存图片</span>
      <img
        src="../../../assets/img/learningGuidePage/report-share-btn.png"
        alt=""
      />
    </div>
  </van-popup>
</template>

<script>
import html2canvas from 'html2canvas';
import { reqTypeList } from '@/api/home';
import StudyProgress from './studyProgress.vue';

export default {
  components: {
    StudyProgress,
  },
  data() {
    return {
      show: true,
      qrcode: '',
      imgUrl: null,
    };
  },
  props: {
    studyInfo: {
      type: Object,
      default: () => { },
    },
    showWeekInfo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  watch: {},
  methods: {
    // 获取分类列表
    async getTypeList() {
      const res = await reqTypeList('STUDY_REPORT_CODE');
      if (res.code === 0 && res.data?.length) {
        this.qrcode = res.data[0].remark;
        setTimeout(() => {
          this.toImage();
        }, 0);
      }
    },
    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题

      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.imgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.imgUrl,
              title: '学习报告',
              content: '',
              icon: '',
            },
            false,
          );
        }
      });
    },
    close() {
      this.$parent.showShare = false;
    },
  },
  created() {
    this.getTypeList();
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
  },
};
</script>
<style lang="scss" scoped>
.popup {
  background: none;
  border-radius: 36px !important;
}
.share {
  position: relative;
  width: 714px;
  height: 980px;
  background: linear-gradient(180deg, #ff6b00 0%, #ff9e6f 100%);
  border-radius: 36px;
  .share-head {
    width: 100%;
    height: 326px;
    // background-image: url('../../../assets/img/learningGuidePage/report-share-head.png');
    // background-repeat: no-repeat;
    // background-size: 100%;
    > img {
      width: 100%;
    }
    .title {
      position: absolute;
      top: 0;
      left: 0;
      padding: 90px 0 0 38px;
      color: #fff;
      font-weight: 400;
      font-size: 25px;
    }
  }
  .section {
    position: absolute;
    top: 131px;
    left: 18px;
    width: 678px;
    height: 830px;
    background: #fff;
    border-radius: 36px;
    .course-name {
      padding: 36px 0 2px 33px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
    }
    .study-progress {
      width: 612px;
      margin: 0 33px;
      padding: 36px 0 0 0;
      border-radius: 0;
    }
    .qihang {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 678px;
      height: 149px;
      background: #f1f6ff;
      border-radius: 0 0 36px 36px;
      .logo {
        width: 199px;
      }
      .code {
        width: 91px;
        height: 91px;
      }
    }
  }
  .poster {
    width: 100%;
  }
}
.share-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: #fff;
    font-weight: 500;
    font-size: 29px;
  }
  img {
    width: 98px;
    height: 82px;
  }
}
</style>
